import Vue from 'vue';

export default {
  async getByPlayer(playerId, filter) {
    return (await Vue.http.post(`/api/pins/byplayer/${playerId}`, filter)).data;
  },
  async getByClient(filter) {
    return (await Vue.http.post('/api/pins', filter)).data;
  }
}



// WEBPACK FOOTER //
// ./src/services/pin.service.js